<template>
  <div class="form-group">
    <label>Add people in CC</label>
    <small class="form-text form-helper">Add as many email as you'd like. They will also be sent the document.</small>
    <div class="row mb-2" v-for="(cc, index) in reviewerCC" :key="index">
      <div class="col-10">
        <TextInput
          v-model="reviewerCC[index]"
          @input="$page.props.errors[`reviewerCC.${index}`] = []"
          :errors="$page.props.errors[`reviewerCC.${index}`] ? $page.props.errors[`reviewerCC.${index}`] : []"
          :validateSuccess="true"
          :validateError="true"
          type="text"
          autocapitalize="off"
          readonly
        />
      </div>
      <div class="col-2">
        <button @click.prevent="removeEmail(index)" class="btn btn-danger btn-block">Remove</button>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-10">
        <TextInput
          v-model="newEmail"
          @input="() => invalidEmail = false"
          :errors="invalidEmail ? ['You must supply a valid email address'] : []"
          :validateError="true"
          type="text"
          autocapitalize="off"
          placeholder="Enter an email..."
        />
      </div>
      <div class="col-2">
        <button @click.prevent="addEmail" class="btn btn-primary btn-block">Add Email Address</button>
      </div>
    </div>
  </div>
</template>

<script>
import TextInput from '@/Shared/Inputs/Text';
import helpers from '@/Mixins/helpers';

export default {
  mixins: [helpers],

  components: {
    TextInput,
  },

  props: {
    reviewerCC: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      newEmail: '',
      invalidEmail: false,
    };
  },

  methods: {
    addEmail() {
      if (!this.validateEmail(this.newEmail)) {
        this.invalidEmail = true;
        return;
      }

      this.invalidEmail = false;
      this.$emit('added', this.newEmail);
      this.newEmail = '';
    },

    removeEmail(index) {
      this.$emit('removed', index);
    },
  },
};
</script>
